<template>
    <p>ChatComponent</p>
</template>